import "./css";
import "./Translation/i18n";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import Routing from "./Routing";
import "bootstrap/dist/css/bootstrap.min.css";
import { ChakraProvider } from "@chakra-ui/react";
ReactDOM.render(
  <ChakraProvider>
    <Router>
      <Routing />
    </Router>
  </ChakraProvider>,

  document.getElementById("root")
);
